import { LayoutService } from '@/layout/service/layout.service';
import { NavegacaoMenuItem, NavegacaoStore, rastrearBlocoMenu, rastrearItemMenu } from '@/layout/store/navegacao.store';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Entrada } from '@shared/interfaces/entrada';
import { BadgeModule } from 'primeng/badge';
import { DrawerModule } from 'primeng/drawer';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-prontuario-menu-drawer',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DrawerModule,
    BadgeModule,
    SkeletonModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
  ],
  templateUrl: './app.prontuario-menu-drawer.component.html',
  styleUrl: './app.prontuario-menu-drawer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppProntuarioMenuDrawer {
  protected readonly layoutService = inject(LayoutService);
  protected readonly store = inject(NavegacaoStore);
  protected readonly rastrearBlocoMenu = rastrearBlocoMenu;
  protected readonly rastrearItemMenu = rastrearItemMenu;

  protected readonly menuNavegacaoDrawerAtivo = computed(
    () => this.layoutService.layoutState().menuNavegacaoDrawerAtivo === true,
  );

  protected readonly semResultadosBuscaMenu = computed(
    () => this.store.termoBuscaMenu().trim().length > 0 && this.store.itensMenu().length === 0,
  );

  protected onDrawerHide(): void {
    this.fecharDrawer();
  }

  protected aoNavegar(): void {
    this.fecharDrawer();
  }

  protected executarComando(item: NavegacaoMenuItem, event: Event): void {
    if (item.disabled === true) return;

    item.command?.({ originalEvent: event, item });
    this.fecharDrawer();
  }

  protected nomeLeito(entrada: Entrada): string {
    const internacao = entrada.internacao as typeof entrada.internacao | null;
    return internacao?.leito?.nome ?? 'Sem leito';
  }

  protected ehIconeMaterial(icone: string | undefined): boolean {
    return !!icone?.includes('material-symbols');
  }

  protected obterGlifoIconeMaterial(icone: string | undefined): string {
    if (icone == null) return '';

    const partes = icone
      .trim()
      .split(/\s+/)
      .filter((p) => p.length > 0);

    if (partes.length === 0) return '';
    return partes.at(-1) ?? '';
  }

  protected obterClassesFonteIconeMaterial(icone: string | undefined): string {
    if (icone == null) return 'text-base shrink-0';

    const partes = icone
      .trim()
      .split(/\s+/)
      .filter((p) => p.length > 0);

    if (partes.length < 2) return `${icone} text-base shrink-0`;

    return `${partes.slice(0, -1).join(' ')} text-base shrink-0`;
  }

  protected onTermoBuscaMenuAlterado(event: Event): void {
    const alvo = event.target;
    if (!(alvo instanceof HTMLInputElement)) return;

    this.store.definirTermoBuscaMenu(alvo.value);
  }

  private fecharDrawer(): void {
    this.layoutService.fecharMenuNavegacaoDrawer();
    document.body.classList.remove('blocked-scroll');
  }
}
